import "./App.css";
import Login from "./pages/Login/Login";
import Home from "./pages/Home/Home";
import Task from "./pages/Task/Task";
import Register from "./pages/Register/Register";
import Search from "./pages/Search/Search";
import ApprovalList from "./pages/ApprovalList/ApprovalList";
import ApprovaledList from "./pages/ApprovalList/ApprovaledList";
import RejectList from "./pages/ApprovalList/RejectList";
import Menu from "./pages/Menu/Menu.jsx";
import JoinInfo from "./pages/JoinInfo/JoinInfo.jsx";
import JoinInfoForGuest from "./pages/JoinInfoForGuest/JoinInfoForGuest.jsx";
import Fans from "./pages/Fans/Fans.jsx";
import CountFans from "./pages/FansCount/FansCount.jsx";
import ADDisplayInfo from "./pages/ADDisplayInfo/ADDisplayInfo.jsx";
import Dashboard from "./pages/Dashboard/Dashboard";
import ADList from "./pages/ADList/ADList";
import BannerManage from "./pages/BannerManage/BannerManage";
import SmallBannerManage from "./pages/SmallBannerManage/SmallBannerManage";
import DataIko from "./pages/DataIko/DataIko";
import DaikaiManage from "./pages/DaikaiManage/DaikaiManage.jsx";
import DaikaiApply from "./pages/DaikaiApply/DaikaiApply.jsx";
import RecommendationCandidates from "./pages/RecommendationCandidates/RecommendationCandidates.jsx";

import {
  BrowserRouter,
  Navigate,
  Outlet,
  Routes,
  Route,
} from "react-router-dom";
import Notice from "./pages/Notice/Notice.js";
import { ToastContainer } from "react-toastify";
import { hasValidSession } from "./utils/auth";
import Analytics from "./pages/Analytics/Analytics";

function ProtectedRoute() {
  return hasValidSession() ? <Outlet /> : <Navigate to="/login" replace />;
}

function App() {
  return (
    <div>
      <BrowserRouter basename="">
        <Routes>
          <Route path="/" element={<Login />}></Route>
          <Route path="/login" element={<Login />}></Route>
          <Route path="/notice" element={<Notice />}></Route>
          <Route path="/daikaiApply" element={<DaikaiApply />}></Route>
          <Route path="/daikaiApply/:daikaiId" element={<DaikaiApply />}></Route>
          <Route element={<ProtectedRoute />}>
            <Route path="/home" element={<Home />}></Route>
            <Route path="/task" element={<Task />}></Route>
            <Route path="/register" element={<Register />}></Route>
            <Route path="/search" element={<Search />}></Route>
            <Route path="/approvallist" element={<ApprovalList />}></Route>
            <Route path="/approvaledlist" element={<ApprovaledList />}></Route>
            <Route path="/rejectedlist" element={<RejectList />}></Route>
            <Route path="/menu" element={<Menu />}></Route>
            <Route path="/joinInfo" element={<JoinInfo />}></Route>
            <Route
              path="/joinInfoForGuest"
              element={<JoinInfoForGuest />}
            ></Route>
            <Route path="/daikaiManage" element={<DaikaiManage />}></Route>
            <Route path="/fans" element={<Fans />}></Route>
            <Route path="/countFans" element={<CountFans />}></Route>
            <Route path="/adDisplayInfo" element={<ADDisplayInfo />}></Route>
            <Route path="/dashboard" element={<Dashboard />}></Route>
            <Route path="/adList" element={<ADList />}></Route>
            <Route path="/bannerManage" element={<BannerManage />}></Route>
            <Route
              path="/smallBannerManage"
              element={<SmallBannerManage />}
            ></Route>
            <Route path="/dataIko" element={<DataIko />}></Route>
            <Route path="/analytics" element={<Analytics />} />
            <Route
              path="/recommendationCandidates"
              element={<RecommendationCandidates />}
            ></Route>
          </Route>
        </Routes>
        <ToastContainer />
      </BrowserRouter>
    </div>
  );
}

export default App;
